module.exports = __webpack_public_path__ + "img/menuIcon5.3795acc3.png";